import { createContext, useReducer, ReactNode, FC, Dispatch, useContext } from 'react'
import { uiContextReducer, INITIAL_STATE } from './uiContextReducer'
import { UiContextDispatchActions, InitialStateType } from './types'

interface UiProviderProps {
	children: ReactNode
}

interface UiContextType extends InitialStateType {
	uiDispatch: Dispatch<UiContextDispatchActions>
}

export const UiContext = createContext<UiContextType>({} as UiContextType)

const UiProvider: FC<UiProviderProps> = ({ children }) => {
	const [uiState, uiDispatch] = useReducer(uiContextReducer, INITIAL_STATE)

	const value = {
		...uiState,
		uiDispatch,
	}
	return <UiContext.Provider value={value}>{children}</UiContext.Provider>
}

export function useUiContext() {
	const state = useContext(UiContext)
	return state
}

export default UiProvider
